import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {normalizePriceInput} from '../../helpers';
import {AmountFieldProps, PriceFormValue} from '../../types/balance-replenishment.types';
import {AmountInput, FieldContainer, SectionTitle} from './styles';

export const AmountField: FC<AmountFieldProps> = ({hasError}) => {
  const {register} = useFormContext<PriceFormValue>();

  return (
    <FieldContainer>
      <SectionTitle>Укажите сумму</SectionTitle>
      <AmountInput
        variant="outlined"
        placeholder="Сумма пополнения"
        error={hasError}
        inputProps={{inputMode: 'decimal'}}
        {...register('price', {
          required: true,
          validate: (v) => /^\d+(,\d{1,2})?$/.test(v.trim()),
          onChange: (e) => {
            e.target.value = normalizePriceInput(String(e.target.value));
          },
        })}
      />
    </FieldContainer>
  );
};
